import { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { EyeIconButton } from "../../../../../assets/common-svg/CommonSvg";
import FilePreviewModal from "../../../../components/common/FilePreview";
import DownloadImageApi from "../../../../../services/downloadImageService";

const PaymentStatusModel = ({ data }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [filePreview, setFilePreview] = useState("");

  const handleDownload = async (id) => {
    try {
      const imgRes = await DownloadImageApi.getDownloadedImageul(id);
      const response = await fetch(imgRes?.data || "");

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      setFilePreview(response?.url);
      setPreviewOpen(true);
    } catch (error) {
      console.log("Download failed. Please try again later.", error);
    }
  };

  const getStatusChipColor = (status) => {
    if (!status) return "default";

    const value = status.toLowerCase();
    if (value.includes("paid") || value.includes("success")) return "success";
    if (value.includes("pending")) return "warning";
    if (value.includes("failed") || value.includes("rejected")) return "error";
    return "default";
  };

  const renderFileContent = (media) => {
    if (!media || media.length === 0) {
      return (
        <Box mt={2}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Files
          </Typography>
          <Box
            className="rounded-lg border border-dashed border-gray-200 bg-gray-50"
            p={2}
          >
            <Typography variant="body2" color="text.secondary">
              No files uploaded.
            </Typography>
          </Box>
        </Box>
      );
    }

    return (
      <Box mt={2}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Files
        </Typography>
        <Box className="space-y-2">
          {media.map((fileValues, keyIndex) => (
            <Box
              key={`key_${keyIndex}`}
              className="flex items-center justify-between rounded-lg bg-gray-50 hover:bg-gray-100 transition-all"
              px={2}
              py={1.5}
            >
              <Typography
                variant="body2"
                className="truncate max-w-xs"
                title={fileValues.file_name}
              >
                {fileValues.file_name}
              </Typography>

              <Box className="flex items-center gap-2">
                {fileValues?.id && (
                  <Tooltip title="View file">
                    <span>
                      <IconButton
                        size="small"
                        onClick={() => handleDownload(fileValues?.id)}
                      >
                        <EyeIconButton bgColor={"#3571FF"} />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <>
      <Card
        elevation={0}
        className="rounded-2xl border border-gray-100 shadow-sm"
      >
        <CardContent className="space-y-4">
          {/* Header */}
          <Box className="flex items-center justify-between">
            <Box>
              <Typography variant="h6" className="font-semibold">
                Payment Status
              </Typography>
              <Typography variant="body2" color="text.secondary">
                View current payment status and remarks
              </Typography>
            </Box>
            <Chip
              label={data?.payment_status || "N/A"}
              color={getStatusChipColor(data?.payment_status)}
              variant="filled"
              className=" mr-3 font-medium"
            />
          </Box>

          <Divider />

          {/* Content */}
          <Box className="space-y-3">

            <Box className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-1">
              <Typography
                variant="subtitle2"
                color="text.secondary"
                className="sm:w-1/3"
              >
                Remarks
              </Typography>
              <Typography
                variant="body2"
                className="sm:w-2/3 whitespace-pre-wrap"
              >
                {data?.remarks || "-"}
              </Typography>
            </Box>

            {renderFileContent(data?.payment_media)}
          </Box>
        </CardContent>
      </Card>

      <FilePreviewModal
        ModalTitle={"File Preview"}
        setOpen={setPreviewOpen}
        open={previewOpen}
        fileURL={filePreview}
      />
    </>
  );
};

export default PaymentStatusModel;
